
import { P2TextLabel } from 'react-bootstrap-common-script';
import { Radio } from './../..'
import { RadioItemInterface } from '../../../../models/interfaces/radio-item.interface'
import { useCallback } from 'react';


interface RadioGroupProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  layout?: "default" | "inline";
  items?: RadioItemInterface[];
  onItemSelect?: (value: any) => void;
  value?: any;
  gap?: number;
  label?: string;
  required?: boolean;
  hasTooltip?: boolean;
  tooltipContent?: string | JSX.Element;
  disabled?: boolean;
  labelBold?: string;
  flexDirection?: "row" | "column";
  r2Enabled?: boolean;
}

function RadioGroup({ required = false, hasTooltip = false, disabled = false, layout = "default", labelBold, flexDirection, tooltipContent, ...props }: RadioGroupProps) {
  const handleItemSelect = useCallback((value: string | boolean | undefined) => () => {
    props?.onItemSelect?.(value);
  }, [props]);

  return (
    <div {...props}>
      {props.label && <P2TextLabel marginBottom='20px' label={props.label} required={required} hasTooltip={hasTooltip} tooltipContent={tooltipContent} bold={labelBold} />}
      <div className={`polymer-radio-group-form ${layout === "default" ? "polymer-radio-group-form__default" : "polymer-radio-group-form__inline"}`} style={{ gap: props.gap, flexDirection: flexDirection }}>
        {props.items?.map((e: RadioItemInterface, _index: number) => {
          return <Radio r2={props.r2Enabled} disabled={disabled} key={`${e.id}`} onClick={handleItemSelect(e.value!)} variant={e.variant} isActive={e.value === props.value} description={e.description} />
        })}
      </div>
    </div>
  )
}

export default RadioGroup